import * as React from "react";
import { Component } from "react";
import { stylesheet } from "typestyle";
import { classNames } from "./utils.js";
export var IconNames;
(function (IconNames) {
    IconNames["refresh"] = "refresh";
    IconNames["lock"] = "lock";
    IconNames["lock_open"] = "lock_open";
    IconNames["error"] = "error";
    IconNames["notifications"] = "notifications";
    IconNames["settings"] = "settings";
    IconNames["warning"] = "warning";
    IconNames["info"] = "info";
    IconNames["backspace"] = "backspace";
    IconNames["arrow_back"] = "arrow_back";
    IconNames["check"] = "check";
    IconNames["chevron_right"] = "chevron_right";
    IconNames["search"] = "search";
    IconNames["space_bar"] = "space_bar";
    IconNames["local_shipping"] = "local_shipping";
    IconNames["cancel_presentation"] = "cancel_presentation";
    IconNames["undo"] = "undo";
    IconNames["build"] = "build";
    IconNames["clear"] = "clear";
    IconNames["skip_previous"] = "skip_previous";
    IconNames["skip_next"] = "skip_next";
    IconNames["pause"] = "pause";
    IconNames["play_arrow"] = "play_arrow";
    IconNames["close"] = "close";
    IconNames["call"] = "call";
    IconNames["email"] = "email";
    IconNames["smartphone"] = "smartphone";
    IconNames["web"] = "web";
    IconNames["airplay"] = "airplay";
    IconNames["textsms"] = "textsms";
    IconNames["send"] = "send";
    IconNames["photo_camera"] = "photo_camera";
    IconNames["create"] = "create";
    IconNames["language"] = "language";
    IconNames["arrow_drop_down"] = "arrow_drop_down";
    IconNames["home"] = "home";
    IconNames["developer_board"] = "developer_board";
    IconNames["router"] = "router";
    IconNames["north"] = "north";
    IconNames["south"] = "south";
    IconNames["block"] = "block";
    IconNames["contact_support"] = "contact_support";
    IconNames["check_box_outline_blank"] = "check_box_outline_blank";
    IconNames["check_box"] = "check_box";
    IconNames["maintenance"] = "handyman";
    IconNames["box_number"] = "looks_one";
    IconNames["visibility_off"] = "visibility_off";
    IconNames["visibility"] = "visibility";
    IconNames["doNotDisturbOn"] = "do_not_disturb_on";
    IconNames["acUnit"] = "ac_unit";
    IconNames["accessible"] = "accessible";
    IconNames["warningAmber"] = "warning_amber";
    IconNames["batteryChargingFull"] = "battery_charging_full";
    IconNames["filterList"] = "filter_list";
})(IconNames || (IconNames = {}));
export class MaterialIcon extends Component {
    render() {
        return React.createElement("i", { className: classNames(styles.icon, styles.materialIcon, this.props.className) }, this.props.icon);
    }
    static get refresh() { return create(IconNames.refresh); }
    static get lock() { return create(IconNames.lock); }
    static get lock_open() { return create(IconNames.lock_open); }
    static get error() { return create(IconNames.error); }
    static get notifications() { return create(IconNames.notifications); }
    static get settings() { return create(IconNames.settings); }
    static get warning() { return create(IconNames.warning); }
    static get info() { return create(IconNames.info); }
    static get backspace() { return create(IconNames.backspace); }
    static get arrow_back() { return create(IconNames.arrow_back); }
    static get check() { return create(IconNames.check); }
    static get chevron_right() { return create(IconNames.chevron_right); }
    static get search() { return create(IconNames.search); }
    static get local_shipping() { return create(IconNames.local_shipping); }
    static get check_box_outline_blank() { return create(IconNames.check_box_outline_blank); }
    static get check_box() { return create(IconNames.check_box); }
    static get maintenance() { return create(IconNames.maintenance); }
    static get do_not_disturb_on() { return create(IconNames.doNotDisturbOn); }
    static get ac_unit() { return create(IconNames.acUnit); }
    static get accessible() { return create(IconNames.accessible); }
    static get warningAmber() { return create(IconNames.warningAmber); }
    static get batteryChargingFull() { return create(IconNames.batteryChargingFull); }
    static get filterList() { return create(IconNames.filterList); }
}
function create(icon) {
    return React.createElement(MaterialIcon, { icon: icon });
}
export class ImageIcon extends Component {
    render() {
        return (React.createElement("i", { className: classNames(styles.imageIcon, this.props.class) },
            React.createElement("img", { alt: styles.imageIconImage, className: classNames(styles.imageIconImage), src: this.props.src, draggable: false })));
    }
}
const styles = stylesheet({
    icon: {
        display: 'inline-block',
        letterSpacing: "normal",
        wordWrap: "normal",
        whiteSpace: "nowrap",
        direction: "ltr",
    },
    materialIcon: {
        fontFamily: 'Material Icons',
        fontWeight: 'normal',
        fontStyle: 'normal',
        textTransform: 'none',
        textRendering: "optimizeLegibility",
        fontFeatureSettings: "liga",
        "-webkit-font-smoothing": "antialiased",
        "-moz-osx-font-smoothing": "grayscale",
    },
    imageIcon: {},
    imageIconImage: {
        display: "block",
        height: "auto",
        maxWidth: "100%",
    }
});
//# sourceMappingURL=icon.js.map